export default __webpack_public_path__ + "static/media/42_4_0.273bf380.png";